import React, { useContext } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


import ThemeContext from "../../../Context/theme/ThemeContext";

const Invoice = ({ InvoiceModel, setInvoiceModel, item, user}) => {
  const { theme } = useContext(ThemeContext);

  const downloadInvoice = () => {
    const invoice = document.getElementById("invoice");

    html2canvas(invoice).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };


  const extractDate = (timestamp) => {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
      {InvoiceModel && (
        <div className="fixed z-[9999] top-0 left-0 w-screen h-screen">
          <div
            className="absolute z-40 bg-black/50 w-full h-full"
            onClick={() => {
              setInvoiceModel(false);
            }}
          ></div>
          <div
            className={` relative px-6 pt-6 pb-6 rounded-xl my-10 z-50 h-[90%] flex flex-col gap-4 w-[90%] lg:w-[70%] mx-auto max-h-[90vh] overflow-y-auto
                     ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
          >
            <button
              className="bg-primarygreen border-2 border-primarygreen hover:bg-transparent hover:text-primarygreen font-pop text-lg text-white font-semibold w-fit self-end rounded-xl py-2 px-4 ease-in-out duration-300"
              onClick={downloadInvoice}
            >
              Download
            </button>
            <div
              className={` shadow-xl   ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              }`}
              id="invoice"
            >
              <div className="bg-primarygreen py-4 px-4 flex justify-between items-center font-pop">
                <h2 className="text-2xl text-white font-bold">Paycott</h2>
                <div className="flex flex-col items-end gap-1 font-pop text-white">
                  <h4 className="text-lg font-medium">{item?.Offer.Seller._id === user._id? (<>{item?.Offer.Buyer.FirstName} {item?.Offer.Buyer.LastName}</>) : (<>{item?.Offer.Seller.FirstName} {item?.Offer.Seller.LastName}</>)}</h4>
                  <h5>Ph No: {item?.Offer.Seller._id === user._id? (<>{item?.Offer.Buyer.Phone}</>) : (<>{item?.Offer.Seller.Phone}</>)}</h5>
                  <h5>Email ID: {item?.Offer.Seller._id === user._id? (<>{item?.Offer.Buyer.Email}</>) : (<>{item?.Offer.Seller.Email}</>)}</h5>
                </div>
              </div>
              <div className={`py-6 min-h-[90vh] px-4 flex flex-col gap-44 justify-between ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              }`}>
                <div className={`flex flex-col gap-6 ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              }`}>
                  <div className={`flex justify-between ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              }`}>
                    <div className="flex font-pop flex-col gap-1">
                      <p>Invoice To:</p>
                      <h4 className="font-semibold text-lg">{item?.Offer.Seller._id === user._id? (<>{item?.Offer.Seller.FirstName} {item?.Offer.Seller.LastName}</>) : (<>{item?.Offer.Buyer.FirstName} {item?.Offer.Buyer.LastName}</>)}</h4>
                    </div>
                    <div className={`flex flex-col gap-1 items-end font-pop ${ theme === "dark" ? "bg-black text-white" : "bg-white" }`}>
                      <h2 className={`text-2xl font-bold ${
                          theme === "dark" ? "bg-black text-white" : "bg-white"
                      }`}>INVOICE</h2>
                      <p
                        className={`text-lightGrey text-sm font-medium
                                             ${
                                               theme === "dark" && "text-white"
                                             }`}
                      >
                        {extractDate(item?.date)}
                      </p>
                      {/*<p*/}
                      {/*  className={` text-lightGrey text-sm font-medium*/}
                      {/*                      ${*/}
                      {/*                        theme === "dark" && "text-white"*/}
                      {/*                      }  `}*/}
                      {/*>*/}
                      {/*  01 July 2023*/}
                      {/*</p>*/}
                    </div>
                  </div>
                  <div>
                    <div className="relative border-b-2 border-black overflow-x-auto">
                      <table className="w-full font-pop text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead
                          className={`text-sm  uppercase border-b-2 border-black 
                               theme === "dark"
                                                     ? "bg-gray-700 text-white"
                                                     : "bg-gray-300 text-gray-700"
                                                 }  `}
                        >
                          <tr>
                            <th scope="col" className="px-6 py-3">
                              ITEM DESCRIPTION
                            </th>
                            <th scope="col" className="px-6 py-3">
                              PRICE
                            </th>
                            <th scope="col" className="px-6 py-3">
                              TOTAL
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            className={` font-pop border-b   ${
                              theme === "dark"
                                ? "bg-gray-700 text-white"
                                : "bg-gray-300 text-gray-700"
                            } `}
                          >
                            <th scope="row" className="px-6 py-4 font-medium ">
                              {item?.Offer.Title}
                            </th>
                            <td className="px-6 py-4">${item?.Offer.Price}</td>
                            <td className="px-6 py-4">${item?.Offer.Price}</td>
                          </tr>
                          {/*<tr*/}
                          {/*  className={` font-pop border-b  ${*/}
                          {/*    theme === "dark"*/}
                          {/*      ? "bg-gray-700 text-white"*/}
                          {/*      : "bg-gray-300 text-gray-700"*/}
                          {/*  } `}*/}
                          {/*>*/}
                          {/*  <th scope="row" className="px-6 py-4 font-medium ">*/}
                          {/*    Flyer Design*/}
                          {/*  </th>*/}
                          {/*  <td className="px-6 py-4">$2000</td>*/}
                          {/*  <td className="px-6 py-4">$2000</td>*/}
                          {/*</tr>*/}
                          {/*<tr*/}
                          {/*  className={` font-pop  ${*/}
                          {/*    theme === "dark"*/}
                          {/*      ? "bg-gray-700 text-white"*/}
                          {/*      : "bg-gray-300  text-gray-700"*/}
                          {/*  } `}*/}
                          {/*>*/}
                          {/*  <th scope="row" className="px-6 py-4 font-medium ">*/}
                          {/*    Website Design*/}
                          {/*  </th>*/}
                          {/*  <td className="px-6 py-4">$2000</td>*/}
                          {/*  <td className="px-6 py-4">$4000</td>*/}
                          {/*</tr>*/}
                        </tbody>
                      </table>
                    </div>

                    <div className="relative overflow-x-auto">
                      <table
                        className={`w-full font-pop text-left rtl:text-right text-gray-500 
                                             ${
                                               theme === "dark" && "text-white"
                                             } `}
                      >
                        <thead
                          className={`text-sm text-gray-700 uppercase
                                                  ${
                                                    theme === "dark" &&
                                                    "text-white bg-gray-700"
                                                  }`}
                        >
                          <tr>
                            <th scope="col" className="px-6 py-3">
                              BANK INFO
                            </th>
                            <th scope="col" className="px-6 py-3">
                              SUB TOTAL
                            </th>
                            <th scope="col" className="px-6 py-3 font-normal">
                              ${item?.Offer.Price}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            className={` font-pop border-b   ${
                              theme === "dark"
                                ? "bg-gray-700 text-white"
                                : "bg-gray-300 text-gray-700"
                            } `}
                          >
                            <th scope="row" className="px-6 py-4 font-medium ">
                              Account No: {item?.Offer.PaymentAccount}
                            </th>
                            <td className="px-6 py-4 font-bold">TAX</td>
                            <td className="px-6 py-4">{item?.Offer.Seller._id === user._id? <>0</> : (<>${item?.Offer.Tax}</>)}</td>
                          </tr>
                          <tr
                            className={` font-pop border-b     ${
                              theme === "dark"
                                ? "bg-gray-700 text-white"
                                : "bg-gray-300 text-gray-700"
                            } `}
                          >
                            <th scope="row" className="px-6 py-4 font-medium ">
                              Code: {item?.Offer.Code}
                            </th>
                            <td className="px-6 py-4 font-semibold">
                              GRAND TOTAL
                            </td>
                            <td className="px-6 py-4">{item?.Offer.Seller._id === user._id? <>${item?.Offer.Price}</> : (<>${item?.Offer.Tax + item?.Offer.Price}</>)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="flex flex-col font-pop gap-2 border-b-2 border-light">
                    <h3 className="text-lg font-bold">Notes</h3>
                    <p>Add the notes for the invoice</p>
                  </div>
                  <p className="font-bold font-pop text-center">
                    Thank You For Your Business
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Invoice;
